import { render, staticRenderFns } from "./DataIList.vue?vue&type=template&id=5a469e2e&scoped=true"
import script from "./DataIList.vue?vue&type=script&lang=js"
export * from "./DataIList.vue?vue&type=script&lang=js"
import style0 from "./DataIList.vue?vue&type=style&index=0&id=5a469e2e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a469e2e",
  null
  
)

export default component.exports